<template>
  <div class="houseList">
    <bv-top></bv-top>
    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" v-if="!isApply">
      中心城区补贴标准：房屋面积100平以下1.5万、100-150平2万、150平以上2.5万。旗县区补贴标准按属地政策执行。
    </van-notice-bar>
<!--    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" v-if="isApply">-->
<!--      补贴款将直接划转到您预留的银行账户，请注意查收。-->
<!--    </van-notice-bar>-->
    <div class="box" v-if="isApply">
      <span class="text" v-if="item.isRemit">
        补贴已发放，请及时查收！
      </span>
      <span class="text" v-else>
        完成申请！
      </span>
    </div>
    <van-card :key="item.htId">
      <div class="title" slot="title">
        <div class="titleContent">合同编号：{{item.htbh}}</div>
      </div>
      <div slot="desc">
        <van-cell-group>
          <van-cell title="购房人" :value="item.gfrmc"/>
          <van-cell title="房屋坐落" :value="item.fwzl"/>
          <van-cell title="房屋面积" :value="item.jzmj+'㎡'"/>
          <van-cell title="不动产权证号" :value="item.bdcqzh"/>
          <van-cell title="补贴金额" :value="'¥'+item.btje" v-if="item.isShow==='0'"/>
          <van-cell title="补贴账户" :value="item.btzh"/>
        </van-cell-group>
      </div>
    </van-card>
    <van-form ref="vanForm" :model="htItem" >
      <van-cell title="申请填报" size="large">
      </van-cell>
      <van-cell-group>
        <van-field
          readonly
          clickable
          name="zhhm"
          :value="htItem.text"
          label="开户人"
          placeholder="请选择补贴账户对应的购房人姓名"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="gfrList"
            @confirm="onConfirm"
            value-key="text"
            @cancel="showPicker = false"
          />
        </van-popup>
        <van-field
          name="sjhm"
          v-model.trim="htItem.sjhm"
          clearable
          label="预留手机号"
          placeholder="请输入在银行预留的联系人手机号"
          :rules="[{required: true}, {validator:validateMobile, message:'手机号格式不正确'}]"
        />
      </van-cell-group>
      <van-row type="flex" justify="center">
        <van-col span="22" style="text-align: center">
          <van-button type="primary" @click="submitForm" :disabled="disabled">提交申请</van-button>
        </van-col>
      </van-row>
    </van-form>
    <van-dialog v-model="isShow" title="提示" :show-confirm-button="false">
      <van-form @submit="onSubmit" >
        <van-field
            v-model="newBankCard"
            name="newBankCard"
            label="新银行卡号"
            placeholder="新银行卡号"
            :rules="[{pattern,message:'请输入正确的银行卡号'}]"
        />
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit" :disabled="disabled">提交</van-button>
        </div>
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
  import Top from '@/views/components/Top'
  import {selectHtDetail, submitTaxSubsidiesApply,submitUpdateNewBankCard} from '@/api/houseResource/fair'
  import '@/styles/maintainFund.scss'
  import {NoticeBar,Dialog} from "vant";
  import {isMobile} from "vant/lib/utils/validate/mobile";

  export default {
    name: "TaxSubsidiesApply",
    data() {
      return {
        rightImg: require('@/assets/listRight.png'),
        item: {},
        isApply: false,
        htItem: {},
        gfrList: [],
        showPicker: false,
        isShow:false,
        newBankCard:"",
        pattern:/^\d{16,19}$/,
        disabled:false
      }
    },
    components: {
      BvTop: Top,
      VanNoticeBar: NoticeBar
    },
    mounted() {
      this.showLoading();
      let htId = this.$route.query.htId;
      selectHtDetail(htId).then(res => {
        this.item = res.data;
        this.isApply = this.item.isApply;
        this.gfrList = this.item.gfrList;
        this.$toast.clear();
      });
    },
    methods: {
      validateMobile(value) {
        return isMobile(value);
      },
      //全屏加载提示
      showLoading() {
        this.$toast.loading({
          // 持续展示 toast
          duration: 0,
          mask: true,
          message: '加载中...'
        });
      },
      onConfirm(value) {
        this.htItem.text = value.text;
        this.htItem.gfrmc = value.gfrmc;
        this.htItem.zjhm = value.zjhm;
        this.showPicker = false;
      },
      submitForm() {
        this.disabled = true;
        this.$refs.vanForm.validate().then(() => {
          this.showLoading();
          this.htItem.htId = this.$route.query.htId;
          this.htItem.applyId = this.item.applyId;
          submitTaxSubsidiesApply(this.htItem).then((res) => {
            this.item = res.data;
            this.isApply = this.item.isApply;
            this.gfrList = this.item.gfrList;
            this.$toast.clear();
            this.$router.push({path: '/personal/subsidies/TaxSubsidies'})
          }).catch((res) => {
            if ("99" == res.response.data.code) {
              this.$toast.clear();
              Dialog.confirm({
                title: '提示',
                message: '银行卡四要素验证失败，请重新输入新的银行卡',
              }).then(() => {
                this.isShow = true;
              }).catch(() => {
                this.$toast.clear();
              })
            }
            //console.log(this.$toast.clear())
          }).finally(() => {
            setTimeout(() => {
              this.disabled = false;
            }, 2000)
          });
        });
      },
      onSubmit(){
        this.disabled = true;
        this.showLoading();
        this.htItem.newBankCard=this.newBankCard;
        this.htItem.fwxz = '1';
        //console.log(this.htItem)
        submitUpdateNewBankCard(this.htItem).then((res)=>{
          this.item = res.data;
          this.isApply = this.item.isApply;
          this.gfrList = this.item.gfrList;
          this.isShow=false;
          this.$toast.clear();
          this.$router.push({path: '/personal/subsidies/TaxSubsidies'})
        }).catch(()=>{
          this.$toast.clear();
          Dialog.confirm({
            title: '提示',
            message: '银行卡四要素验证失败，请重新输入正确的银行卡',
          }).then(() => {
            this.isShow=true;
          }).catch(()=>{
            this.$toast.clear();
          }).finally(() => {
            setTimeout(() => {
              this.disabled = false;
            }, 2000)
          });
        }).finally(() => {
          setTimeout(() => {
            this.disabled = false;
          }, 2000)
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .box {
    position: absolute;
    font-weight: bold;
    top: 45%;
    left: 46%;
    margin: -20px 0 0 -55px;
    font-size: 35px;
    color: red;
    border: 4px solid red;
    border-radius: 10px;
    z-index: 2000;
    background-color: white;
  }

  .text {
    padding: 10px;
  }
</style>
